// CouponSourceContext.tsx
import { createContext } from "react";

interface CouponSourceContextValue {
  couponSource: "backend" | "manual" | "list" | null;
  setCouponSource: (source: "backend" | "manual" | "list" | null) => void;
}

export const CouponSourceContext = createContext<CouponSourceContextValue>({
  couponSource: null,
  setCouponSource: () => void 0,
});